/* eslint-disable no-shadow */
export enum StatusEnum {
  WAITING = "WAITING",
  FINISHED = "FINISHED",
  CONCLUDED = "CONCLUDED",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  CREATED = "CREATED",
  INTEGRATION_SENT = "INTEGRATION_SENT",
  INTEGRATION_FAILED = "INTEGRATION_FAILED",
  INTEGRATION_SUCCESS = "INTEGRATION_SUCCESS",
  INTEGRATION_ERROR = "INTEGRATION_ERROR",
  INTEGRATION_TIMEOUT = "INTEGRATION_TIMEOUT",
  INTEGRATION_CANCEL_REQUESTED = "INTEGRATION_CANCEL_REQUESTED",
  INTEGRATION_CANCELED = "INTEGRATION_CANCELED",
  INTEGRATION_CANCEL_FAILED = "INTEGRATION_CANCEL_FAILED",
  PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  CONFIRMED = "CONFIRMED",
  EXPIRED = "EXPIRED",
}


export const statusEnumList = [
  { value: 0, label: "Aguardando", ENUM: StatusEnum.WAITING },
  { value: 1, label: "Concluída", ENUM: StatusEnum.FINISHED },
  { value: 1, label: "Concluída", ENUM: StatusEnum.CONCLUDED },
  { value: 2, label: "Cancelado", ENUM: StatusEnum.CANCELED },
  { value: 3, label: "Falha", ENUM: StatusEnum.FAILED },
  { value: 4, label: "Pendente", ENUM: StatusEnum.PENDING },
  { value: 5, label: "Processando", ENUM: StatusEnum.PROCESSING },
  { value: 6, label: "Criada", ENUM: StatusEnum.CREATED },
  { value: 7, label: "Integração - Enviada", ENUM: StatusEnum.INTEGRATION_SENT },
  { value: 8, label: "Integração - Falha no Envio", ENUM: StatusEnum.INTEGRATION_FAILED },
  { value: 9, label: "Integração - Sucesso", ENUM: StatusEnum.INTEGRATION_SUCCESS },
  { value: 10, label: "Integração - Erro", ENUM: StatusEnum.INTEGRATION_ERROR },
  { value: 11, label: "Integração - Timeout", ENUM: StatusEnum.INTEGRATION_TIMEOUT },
  { value: 12, label: "Integração - Cancelamento Solicitado", ENUM: StatusEnum.INTEGRATION_CANCEL_REQUESTED },
  { value: 13, label: "Integração - Cancelada", ENUM: StatusEnum.INTEGRATION_CANCELED },
  { value: 14, label: "Integração - Falha no Cancelamento", ENUM: StatusEnum.INTEGRATION_CANCEL_FAILED },
  { value: 15, label: "Pendente de Confirmação", ENUM: StatusEnum.PENDING_CONFIRMATION },
  { value: 16, label: "Confirmada", ENUM: StatusEnum.CONFIRMED },
  { value: 17, label: "Expirada", ENUM: StatusEnum.EXPIRED },
];

